import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "../api/apiClient";

export interface QuestionNotificationItem {
  programId: string;
  bookingId: string | null;
  programTitle: string;
  programIcon: string;
  pendingCount: number;
  questions: Array<{
    id: string;
    text: string;
    type: string;
    askedOn: string;
  }>;
}

export interface NotificationState {
  loading: boolean;
  totalPendingCount: number;
  items: QuestionNotificationItem[];
  error: string | null;
  lastNotifiedCount: number;
}

const initialState: NotificationState = {
  loading: false,
  totalPendingCount: 0,
  items: [],
  error: null,
  lastNotifiedCount: 0,
};

export const fetchUserNotifications = createAsyncThunk(
  "notifications/fetchUserNotifications",
  async (_, thunkAPI) => {
    try {
      const response = await apiClient.get("/api/v1/bookings/notifications");
      return response.data.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch notifications",
      );
    }
  },
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    clearNotifications: (state) => {
      state.totalPendingCount = 0;
      state.items = [];
    },
    setLastNotifiedCount: (state, action) => {
      state.lastNotifiedCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.totalPendingCount = action.payload?.totalPendingCount || 0;
        state.items = action.payload?.items || [];
      })
      .addCase(fetchUserNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearNotifications, setLastNotifiedCount } =
  notificationSlice.actions;
export default notificationSlice.reducer;
